export default "__VITE_ASSET__v6EyYDD___"